import FillArrow from "@assets/svg/fill-arrow.svg";
import SearchIcon from "@assets/svg/search.svg";
import JobsCard from "@components/cards/jobs-card";
import CustomSelectOption from "@components/CustomSelectOption";
import DropDown from "@components/dropDown";
import { Button, Spinner } from "@components/index";
import Pagination from "@components/Pagination";
import { CooperationTypeBy, SortJobsBy } from "@interfaces/index";
import { setJobSearchData } from "@store/reducers/jobs-search";
import Sort from "assets/svg/sort.svg";
import gate from "gate";
import debounce from "lodash/debounce";
import React, { FC, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";

import useClickOutside from "../../../../src/hooks/click-outside";
import { generateUuidForReactList, getJobByEnum } from "../../../../src/utils";

interface Props {}
const sortList = [
  { title: "جدیدترین فرصت‌های شغلی", value: SortJobsBy.RecentlyAdded },
  { title: "بیشترین بازدید", value: SortJobsBy.MostlyViewed },
  { title: "فرصت‌های شغلی آرشیو", value: SortJobsBy.Archive },
];
const cooperationType = [
  { title: "تمام وقت", value: CooperationTypeBy.FullTime },
  { title: "پاره وقت", value: CooperationTypeBy.HalfTime },
  { title: "پروژه‌ای / قراردادی", value: CooperationTypeBy.Project },
];
const list = [
  { key: "12", value: "نمایش 12" },
  { key: "24", value: "نمایش 24" },
  { key: "36", value: "نمایش 36" },
  { key: "48", value: "نمایش 48" },
];
const JobsContainer: FC<Props> = ({}) => {
  const dispatch = useDispatch();
  const state = useSelector((state: any) => state.jobsSearch);
  const { jobSearchData } = state;
  const isFirstMounted = useRef(true);
  const { mutate, data, isLoading }: any = useMutation(gate.jobsHome);
  const {
    mutateAsync: mutateSearchInput,
    data: dataSearchInput,
    isLoading: isLoadingSearchInput,
  }: any = useMutation(gate.jobsSearchInput);
  const [isActiveField, setIsActiveField] = useState<string>("");
  const [cooperationTypeFoundList, setCooperationTypeFoundList] = useState<
    { title: string; value: CooperationTypeBy }[]
  >([]);
  const [isOpen, setIsOpen] = useState({
    cooperationType: false,
    city: false,
    jobtitle: false,
  });
  const [value, setValue] = useState({
    cooperationType:
      jobSearchData.jobSearchDto.cooperationType === -1
        ? { title: "", value: -1 }
        : cooperationType.find(
            (item: any) =>
              jobSearchData.jobSearchDto.cooperationType === item.value
          ),
    city: jobSearchData.jobSearchDto.city,
    jobtitle: jobSearchData.jobSearchDto.jobTitle,
  });
  const cooperationTypeRef = useRef<HTMLDivElement | null>(null);
  const cityRef = useRef<HTMLDivElement | null>(null);
  const jobtitleRef = useRef<HTMLDivElement | null>(null);
  const onCooperationTypeOutside = () => {
    setIsOpen({
      ...isOpen,
      cooperationType: false,
    });
  };
  const onCityOutside = () => {
    setIsOpen({
      ...isOpen,
      city: false,
    });
  };
  const onJobtitleOutside = () => {
    setIsOpen({
      ...isOpen,
      jobtitle: false,
    });
  };

  const [totalCount, setTotalCount] = useState(null);
  const pageNumbersHandler = (pageNumber: number, pageSize: number) => {
    if (totalCount) {
      const totalPages =
        totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
      // last page
      if (pageNumber === totalPages) {
        return (
          <>
            {pageNumber * pageSize - pageSize + 1} - {totalCount}
          </>
        );
        // first page
      } else if (pageNumber === 1) {
        return (
          <>
            {pageNumber} - {pageSize}
          </>
        );
        // middle pages
      } else {
        return (
          <>
            {pageNumber * pageSize - pageSize + 1} - {pageNumber * pageSize}
          </>
        );
      }
    }
    return null;
  };
  // const [searchData, setSearchData] = useState({
  //   searchDto: {
  //     search: "",
  //     pageSize: 12,
  //     pageNumber: 1,
  //     sortBy: "",
  //     isSortAsc: true,
  //   },
  //   jobSearchDto: {
  //     jobTitle: "",
  //     city: "",
  //     cooperationType: 0,
  //   },
  // });
  const getType = (item: any, type: string) => {
    const found = item.items.filter((values: any) => values.fieldName === type);
    if (found && found.length) {
      if (type === "Image") {
        return found[0].value ?? "images/nc-img.png";
      }
      if (type === "Price" || type === "Discount") {
        return found[0].value.replaceAll(".00", "");
      }
      return found[0].value;
    }
    return undefined;
  };
  const onShowChange = (data: { key: string; value: string }) => {
    dispatch(
      setJobSearchData({
        ...jobSearchData,
        searchDto: {
          ...jobSearchData.searchDto,
          pageSize: +data.key,
          pageNumber: 1,
        },
      })
    );
  };
  const onPageChange = (page: number) => {
    // scrollToPostsWrapper();

    dispatch(
      setJobSearchData({
        ...jobSearchData,
        searchDto: {
          ...jobSearchData.searchDto,
          pageNumber: page,
        },
      })
    );
  };
  useEffect(() => {
    mutate(jobSearchData, {
      onSuccess: (data: any) => {
        setTimeout(() => {
          if (!isFirstMounted.current) {
            const getOffsetTop =
              document.getElementById("postsWrapper")?.offsetTop;
            window.scrollTo({
              top:
                getOffsetTop && getOffsetTop > 0
                  ? getOffsetTop - 30
                  : getOffsetTop,
              behavior: "smooth",
            });
          }
          if (isFirstMounted.current) {
            isFirstMounted.current = false;
          }
        }, 0);
        setTotalCount(data?.pagination.totalCount);
      },
    });
  }, [jobSearchData]);
  useClickOutside(cooperationTypeRef, onCooperationTypeOutside);
  useClickOutside(cityRef, onCityOutside);
  useClickOutside(jobtitleRef, onJobtitleOutside);
  const handleCooperationTypeSearch = (e: any) => {
    setValue({
      ...value,
      cooperationType: {
        title: e.target.value,
        value: typeof e.target.value === "string" ? -1 : e.target.value,
      },
    });
    setCooperationTypeFoundList(
      cooperationType.filter((item) => item.title.includes(e.target.value))
    );
    setIsOpen({
      ...isOpen,
      cooperationType: true,
    });
  };
  const delayedQuery = useRef(
    debounce((data: { field: string; text: string }) => {
      setIsActiveField(data.field);
      if (data.field === "jobtitle") {
        mutateSearchInput(
          {
            searchField: data.field,
            searchValue: data.text,
          },
          {
            onSuccess: (data: any) => {
              setIsOpen({
                ...isOpen,
                jobtitle: true,
              });
            },
          }
        );
      } else {
        mutateSearchInput(
          {
            searchField: data.field,
            searchValue: data.text,
          },
          {
            onSuccess: (data: any) => {
              setIsOpen({
                ...isOpen,
                city: true,
              });
            },
          }
        );
      }
    }, 500)
  ).current;
  const onSearch = () => {
    dispatch(
      setJobSearchData({
        ...jobSearchData,
        searchDto: {
          ...jobSearchData.searchDto,
          pageNumber: 1,
        },
        jobSearchDto: {
          jobTitle: value.jobtitle,
          city: value.city,
          cooperationType: value?.cooperationType?.value,
        },
      })
    );
  };
  const onSortChange = (value: any) => {
    dispatch(
      setJobSearchData({
        ...jobSearchData,
        searchDto: {
          ...jobSearchData.searchDto,
          sortBy: value.toString(),
          pageNumber: 1,
        },
      })
    );
  };
  return (
    <>
      <div className="flex flex-col gap-2 lg:flex-row">
        <div className="grid w-full gap-2 lg:grid-cols-3">
          <div className="relative">
            <label className="flex h-full cursor-default flex-nowrap items-center gap-2 rounded-md border border-gray-550 py-1 pl-1 pr-4 shadow-jobsShadow">
              <SearchIcon className="shrink-0" />
              <input
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setValue({
                    ...value,
                    jobtitle: e.target.value,
                  });
                  delayedQuery({ text: e.target.value, field: "jobtitle" });
                }}
                value={value.jobtitle}
                type="text"
                placeholder="شغل : مشاوره حقوقی و ..."
                className="w-full py-2 pl-1 text-xs placeholder-gray-550 outline-none md:pl-4 md:text-base"
              />
              {isLoadingSearchInput && isActiveField === "jobtitle" ? (
                <Spinner className="mx-auto ml-4 h-5 w-5 animate-opacity animate-fade-in-down" />
              ) : undefined}
            </label>
            {!isLoadingSearchInput && isOpen.jobtitle ? (
              <div
                className="custom-scrollbar absolute top-[110%] right-0 z-[99] max-h-[205px] w-full overflow-auto rounded-b-lg bg-white py-2 shadow"
                ref={jobtitleRef}
              >
                {dataSearchInput && dataSearchInput.data ? (
                  dataSearchInput.data.length ? (
                    dataSearchInput.data.map((item: string) => {
                      return (
                        <button
                          type="button"
                          onClick={() => {
                            setValue({
                              ...value,
                              jobtitle: item,
                            });
                            setIsOpen({
                              ...isOpen,
                              jobtitle: false,
                            });
                          }}
                          className={`block w-full px-4 py-1 text-right hover:text-blue-550 hover:drop-shadow-shadow100`}
                        >
                          {item}
                        </button>
                      );
                    })
                  ) : (
                    <p className="px-4 py-1 text-sm">موردی یافت نشد</p>
                  )
                ) : undefined}
              </div>
            ) : undefined}
          </div>
          <div className="relative">
            <label className="flex h-full cursor-default flex-nowrap items-center gap-2 rounded-md border border-gray-550 py-1 pl-1 pr-4 shadow-jobsShadow">
              <SearchIcon className="shrink-0" />
              <input
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setValue({
                    ...value,
                    city: e.target.value,
                  });
                  delayedQuery({ text: e.target.value, field: "city" });
                }}
                value={value.city}
                type="text"
                placeholder="شهر : تهران، کرج، یزد و ..."
                className="w-full py-2 pl-1 text-xs placeholder-gray-550 outline-none md:pl-4 md:text-base"
              />
              {isLoadingSearchInput && isActiveField === "city" ? (
                <Spinner className="mx-auto ml-4 h-5 w-5 animate-opacity animate-fade-in-down" />
              ) : undefined}
            </label>
            {!isLoadingSearchInput && isOpen.city ? (
              <div
                className="custom-scrollbar absolute top-[110%] right-0 z-[99] max-h-[205px] w-full overflow-auto rounded-b-lg bg-white py-2 shadow"
                ref={cityRef}
              >
                {dataSearchInput && dataSearchInput.data ? (
                  dataSearchInput.data.length ? (
                    dataSearchInput.data.map((item: string) => {
                      return (
                        <button
                          type="button"
                          onClick={() => {
                            setValue({
                              ...value,
                              city: item,
                            });
                            setIsOpen({
                              ...isOpen,
                              city: false,
                            });
                          }}
                          className={`block w-full px-4 py-1 text-right hover:text-blue-550 hover:drop-shadow-shadow100`}
                        >
                          {item}
                        </button>
                      );
                    })
                  ) : (
                    <p className="px-4 py-1 text-sm">موردی یافت نشد</p>
                  )
                ) : undefined}
              </div>
            ) : undefined}
          </div>
          <div className="relative">
            <label className="flex h-full cursor-default flex-nowrap items-center gap-2 rounded-md border border-gray-550 py-1 pl-1 pr-4 shadow-jobsShadow">
              <SearchIcon />
              <input
                onChange={handleCooperationTypeSearch}
                onFocus={() => {
                  setCooperationTypeFoundList(cooperationType);
                  setIsOpen({
                    ...isOpen,
                    cooperationType: true,
                  });
                }}
                value={value?.cooperationType?.title}
                type="text"
                placeholder="نوع همکاری: پاره وقت، تمام وقت و ..."
                className="w-full py-2 pl-1 text-xs placeholder-gray-550 outline-none md:pl-4 md:text-base"
              />
            </label>
            {cooperationTypeFoundList.length && isOpen.cooperationType ? (
              <div
                className="absolute top-[110%] right-0 z-[99] w-full rounded-b-lg bg-white py-2 shadow"
                ref={cooperationTypeRef}
              >
                {cooperationTypeFoundList.map((item: any) => {
                  return (
                    <button
                      type="button"
                      onClick={() => {
                        setValue({
                          ...value,
                          cooperationType: {
                            title: item.title,
                            value: item.value,
                          },
                        });
                        setIsOpen({
                          ...isOpen,
                          cooperationType: false,
                        });
                      }}
                      className={`block w-full px-4 py-1 text-right hover:text-blue-550 hover:drop-shadow-shadow100`}
                    >
                      {item.title}
                    </button>
                  );
                })}
              </div>
            ) : undefined}
          </div>
        </div>
        <div className="rounded-md border border-gray-550 p-2 shadow-jobsShadow lg:w-[155px]">
          <Button
            CClassName="bg-yellow-450 font-bold rounded py-3 w-full text-xs 2xl:text-base px-3 text-black"
            onClick={onSearch}
          >
            شغلتو پیدا کن
          </Button>
        </div>
      </div>
      <div
        className="mt-8 flex flex-col justify-between gap-4 md:flex-row"
        id="postsWrapper"
      >
        <div className="text-center md:text-right">
          <p className="text-base font-bold text-blue-550 md:text-xl">
            کل آگهی‌های منتشر شده در دادبانان :{" "}
            <span className="font-medium">{data?.data?.allJobCount}</span>
          </p>
          <p className="mt-2 text-base font-bold text-green-550 md:text-xl">
            فرصت‌های شغلی فعال :{" "}
            <span className="font-medium">{data?.data?.activeJobCount}</span>
          </p>
        </div>
        <div className="flex items-center justify-center md:justify-start">
          <div className="flex items-center">
            <Sort className="relative z-[99] md:hidden" />
            <span className="hidden md:inline-block">مرتب‌سازی بر اساس</span>
          </div>
          <DropDown
            title={getJobByEnum(+jobSearchData.searchDto.sortBy) ?? "همه"}
            Icon={FillArrow}
            isLeft={true}
            btnClass="-mr-3 md:mr-0 !justify-end focus-within:!bg-transparent !text-base !font-bold focus-within:!shadow-none pl-0 gap-x-5 border-none"
            menu_class="md:!-right-10 xl:right-0"
          >
            <ul className="z-50 flex w-52 flex-col gap-y-2 rounded-lg bg-white p-2">
              {sortList.map(({ title, value }) => (
                <li
                  onClick={() => onSortChange(value)}
                  key={generateUuidForReactList()}
                  className={`cursor-pointer hover:text-blue-550 hover:drop-shadow-shadow100 ${
                    +jobSearchData.searchDto.sortBy === value &&
                    "text-blue-550 drop-shadow-shadow100"
                  }`}
                >
                  {title}
                </li>
              ))}
            </ul>
          </DropDown>
        </div>
      </div>
      {isLoading ? (
        <div className="h-32">
          <Spinner className="mx-auto h-10 w-10 animate-opacity animate-fade-in-down" />
        </div>
      ) : (
        <>
          {data?.data?.jobList.rows.length ? (
            <div className="mt-8 grid grid-cols-1 gap-7 md:grid-cols-2 xl:grid-cols-3">
              {data?.data?.jobList.rows.map((item: any) => {
                return (
                  <>
                    <JobsCard
                      info={{
                        JobTitle: getType(item, "JobTitle"),
                        OrganizationName: getType(item, "OrganizationName"),
                        Salary: getType(item, "Salary"),
                        CooperationType: getType(item, "CooperationType"),
                        Remote: getType(item, "Remote"),
                        Neighbourhood: getType(item, "Neighbourhood"),
                        City: getType(item, "City"),
                        Status: getType(item, "Status"),
                        Id: getType(item, "Id"),
                      }}
                      key={JSON.stringify(getType(item, "id"))}
                    />
                  </>
                );
              })}
            </div>
          ) : (
            <p className="my-16 text-center text-xl">آگهی شغلی وجود ندارد</p>
          )}
        </>
      )}
      <div className="mt-8 grid grid-cols-1 md:mb-0 md:grid-cols-2">
        <div>
          {totalCount && totalCount > jobSearchData?.searchDto?.pageSize ? (
            <Pagination
              totalCount={totalCount}
              pageSize={jobSearchData?.searchDto?.pageSize}
              onPageChange={onPageChange}
              selectedPage={jobSearchData.searchDto.pageNumber}
            />
          ) : undefined}
        </div>
        <div>
          {(totalCount && totalCount > jobSearchData?.searchDto?.pageSize) ||
          jobSearchData?.searchDto?.pageSize !== 12 ? (
            <div className="mt-4 flex items-center justify-center md:mt-0 md:justify-end">
              <span className="ml-5">
                نمایش{" "}
                {pageNumbersHandler(
                  jobSearchData?.searchDto?.pageNumber,
                  jobSearchData?.searchDto?.pageSize
                )}{" "}
                از {totalCount}
              </span>
              <CustomSelectOption
                list={list}
                isRtl={false}
                onChange={onShowChange}
                selectedKey={list.find(
                  (item) => +item.key === jobSearchData?.searchDto?.pageSize
                )}
              />
            </div>
          ) : undefined}
        </div>
      </div>
    </>
  );
};

export default JobsContainer;
